// ----------------------------------------------------------------------------
// Template: Search
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/pagination/pagination';
import 'snippets/search-form/search';

import 'sections/header/header';
import 'sections/page-header/page-header';
import 'sections/footer/footer';

// Styles
import './_search.scss';
